import { gql } from "graphql-tag";

import { getSeoFields, getMetaFields } from "~/mixins/seoMixin";

const PAGE_TYPE = "Bedbuilder";

const QUERY_BEDBUILDER = gql`
  query bedbuilder($uid: String!, $lang: String = "en-in") {
    ${PAGE_TYPE}:bedbuilder(uid: $uid, lang:$lang) {
      title
      ...${PAGE_TYPE}SEOFields
      ...${PAGE_TYPE}MetaFields
    }
  }
  ${getSeoFields(PAGE_TYPE)}
  ${getMetaFields(PAGE_TYPE)}
`;

export { PAGE_TYPE, QUERY_BEDBUILDER };
